import { render, staticRenderFns } from "./profilsablon.vue?vue&type=template&id=727b9234&"
import script from "./profilsablon.vue?vue&type=script&lang=js&"
export * from "./profilsablon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports